import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import {
  ConfigService,
  EntityService,
  TokenService
} from 'viggo-sistemas-core-web';
import { ILinhaProducao } from '../models/linha_producao.model';

export interface IContagem {
  id: string;
  descricao: string;
  quantidade: number;
}
interface IResultContagem {
  id: string;
  contagem: IContagem[];
}
export interface IContagemProcessos {
  id: string;
  descricao: string;
  count: number;
  gerencia_partes: boolean;
}
interface IResultContagemProcessos {
  id: string;
  processos_count: IContagemProcessos[];
}

@Injectable()
export class LinhaProducaoService extends EntityService<ILinhaProducao> {
  constructor(
    protected configService: ConfigService,
    protected tokenService: TokenService
  ) {
    super({
      baseEntityEndPoint: 'linha_producao',
      urlBackend: configService.backendURL
    });
  }

  /**
   * Contagem de etapas
   * @param linha_producao_id
   * @param tipo
   * @returns
   */
  getContagem(where: any): Observable<{ linha_producao: IResultContagem }> {
    const url = `${this.baseURL}/${where.linha_producao_id}/get_contagem`;
    let params = new HttpParams();
    const headers = this.getHeader();
    params = params.append('domain_id', this.tokenService.getDomain().id);
    if (where) {
      if (typeof where === 'object') {
        Object.keys(where).forEach(key => {
          if (
            key !== 'linha_producao_id' &&
            key !== 'etapa_id' &&
            key !== 'processo_id'
          ) {
            if (typeof where[key] === 'object') {
              Object.keys(where[key]).forEach(k => {
                if(k !== 'linha_producao_id')
                  params = params.append(`${[key]}.${[k]}`, where[key][k]);
              });
            } else {
              params = params.append(`${key}`, where[key]);
            }
          }
        });
      }
    }
    return this.http.get<{ linha_producao: IResultContagem }>(url, {
      headers,
      params
    });
  }

  /**
   * Contagem de processos
   * @param linha_producao_id
   * @param tipo
   * @returns
   */
  getContagemProcessos(
    linha_producao_id: string,
    tipo: string
  ): Observable<{ linha_producao: IResultContagemProcessos }> {
    const url = `${this.baseURL}/${linha_producao_id}/processos_count`;
    let params = new HttpParams();
    const headers = this.getHeader();
    params = params.append('domain_id', this.tokenService.getDomain().id);
    if (tipo === 'gerenciamento') {
      params = params.append('gerencia_partes', true);
      params = params.append('filtra_processos', true);
    }
    return this.http.get<{ linha_producao: IResultContagemProcessos }>(url, {
      headers,
      params
    });
  }
}
